import { Box } from "@outschool/backpack";
import { Container, Modal } from "@outschool/ui-legacy-component-library";
import React from "react";

import ActivityEnrollableTimes from "../activityEnrollableTimes/ActivityEnrollableTimes";
import { AvailableTimesWrapper } from "../availableTimes/AvailableTimesWrapper";
import ActivityDetailDescription from "../sections/ActivityDetailDescription";
import LearningGoals from "../sections/LearningGoals";
import OtherDetails from "../sections/OtherDetails";
import Overview from "../sections/Overview";
import { ReviewsSection } from "../sections/Reviews";
import SyllabusSummary from "../sections/SyllabusSummary";
import TeacherSection from "../sections/TeacherSection";
import ClassDetailsNav from "../subcomponents/ClassDetailsNav";
import MobileActivityHeader from "../subcomponents/MobileActivityHeader";
import SelfPacedAvailableNow from "../subcomponents/SelfPacedAvailableNow";
import { hasOneOnOneAvailabilities } from "../utils";
import { MobileContainerProps } from "./ClassDetailsMainBody";

export default function MobileContainer({
  activity,
  activityWithEnrollableTimes,
  classNavTabs,
  isAvailabilityModalOpen,
  leader,
  onClickMoreLikeThis,
  onClickViewReviews,
  refsContainer,
  setIsAvailabilityModalOpen,
  setTabValue,
  tabValue,
}: MobileContainerProps) {
  return (
    <>
      <Box
        ref={refsContainer.about.header}
        flex
        sx={{ flexDirection: "column" }}
      >
        <MobileActivityHeader
          activity={activity}
          leader={leader}
          onClickViewReviews={onClickViewReviews}
        />
      </Box>
      {activity.isSelfPaced && (
        <Container
          ref={refsContainer.schedule.sections}
          sx={{ marginTop: "2em" }}
        >
          <SelfPacedAvailableNow activity={activity} />
        </Container>
      )}
      <Modal
        stickyHeader
        open={!!isAvailabilityModalOpen}
        onClose={() =>
          !!setIsAvailabilityModalOpen && setIsAvailabilityModalOpen(false)
        }
        sx={{ padding: "1.25em" }}
      >
        {(hasOneOnOneAvailabilities(activityWithEnrollableTimes) &&
          activity.canEnroll && (
            <ActivityEnrollableTimes
              activity={activityWithEnrollableTimes!}
              leader={leader}
            />
          )) || (
          <AvailableTimesWrapper
            activity={activity}
            onClickMoreLikeThis={onClickMoreLikeThis}
          />
        )}
      </Modal>
      <ClassDetailsNav tabs={classNavTabs ?? []} />
      <Box
        flex
        sx={{
          marginTop: "6.4rem",
          flexDirection: "column",
          gap: "8rem",
          marginX: 16,
        }}
      >
        <Overview
          activity={activity}
          headerRef={refsContainer.about.overview}
        />
        <ActivityDetailDescription
          activity={activity}
          headerRef={refsContainer.about.classExperience}
        />
        <LearningGoals
          learningGoals={activity.learningGoals}
          headerRef={refsContainer.learningOverview.learningGoals}
        />
        <SyllabusSummary
          activity={activity}
          headerRef={refsContainer.learningOverview.syllabus}
        />
        <OtherDetails
          activity={activity}
          headerRef={refsContainer.learningOverview.otherDetails}
        />
        <TeacherSection
          activity={activity}
          leader={leader}
          onClickViewReviews={onClickViewReviews}
          teacherHeaderRef={refsContainer.teacher.header}
          credentialsRef={refsContainer.teacher.expertise}
        />
        {!!tabValue && !!setTabValue && (
          <ReviewsSection
            activity={activity}
            reviewsRef={refsContainer.reviews}
            setTabValue={setTabValue}
            tabValue={tabValue}
          />
        )}
      </Box>
    </>
  );
}
